
import React, { useState, useEffect, FunctionComponent } from "react";
import Topbar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import { NEWS_COLUMNS } from "../../Values/tables";
import CustomTable from "../../Components/CustomTable/CustomTable";
import styles from './NewsPanel.module.css';
import { fetchNews } from "../../Services/organizations";
import NewsModal from "../../Components/Modals/NewsModal/NewsModal";
import DeleteSelectedModal from "../../Components/Modals/DeleteSelectedModal/DeleteSelectedModal";
import { themeColors } from "../../Components/theme";
import { useMediaQuery } from "@material-ui/core";
import { searchNewsData } from "../../Values/utils";
type props = {
  history: any;
  organizationId: any;
  theme: any;
};
const NewsPanel: FunctionComponent<props> = ({ history, organizationId, theme }) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [searchQuery, setsearchQuery] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [newsModal, setNewsModal] = useState(false);
  const [news, setNews] = useState<any[] | undefined>(undefined);
  const [status, setStatus] = useState("ALL");
  const [temporaryData, setTemporaryData] = useState<any[]>([]);
  const [owner, setOwner] = useState(false);
  const [deletePopup, setDeletePopop] = useState(false);
  const [clearFilterTable, setClearFilterTable] = useState(false);

  useEffect(() => {
    if (organizationId) {
      fetchNews(organizationId, (val) => setNews(val));
    }
  }, [organizationId]);

  const clearSelectedRowsData = () => {
    setSelectedRowsData([]);
    setSelectedRows([]);
  };

  useEffect(() => {
    if (news) {
      let data: any[] = [];
      news.forEach((item) => {
        data.push(item);
      });
      setFilterData(data);
    }
  }, [news]);

   useEffect(() => {
      if (news) {
        const data = searchNewsData(
          news,
          searchQuery
        );
        setFilterData(data);
      }
      // eslint-disable-next-line
    }, [searchQuery, news]);

  useEffect(() => {
    if (selectedRows.length > 0) {
      setOwner(true);
    } else if (selectedRows.length === 0) {
      setOwner(false);
    }
  }, [selectedRows]);

  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };

  const topBarStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, width: "97%" }
  const parentStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark }
  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...parentStyles }}>
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...topBarStyles }}>
          <Topbar
            history={history}
            title={"Add News Link"}
            path={"/addUsers"}
            onChange={(val) => setsearchQuery(val)}
            filterText="Status"
            setColumnModal={(data) => setColumnModal(data)}
            show={true}
            owner={owner}
            deleteSelected={() => {
              setDeletePopop(true);
            }}
            showStatusBox={true}
            setApiModal={(data) => setNewsModal(data)}
            setStatus={(status) => setStatus(status)}
            status={status}
            clearFilter={handleClearFilter}
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px" }}>
          <CustomTable
            tableColumns={NEWS_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="NEWS"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            setSearchedItem={(val) => setsearchQuery(val)}
            clearFilterTable={clearFilterTable}
          />
          {deletePopup && (
            <DeleteSelectedModal
              data={selectedRowsData}
              clearSelectedRowsData={clearSelectedRowsData}
              open={deletePopup}
              tableType={"NEWS"}
              setOwner={setOwner}
              newsData={news}
              close={() => {
                setDeletePopop(false);
              }}
            />
          )}
        </div>
      </div>
      {newsModal === true && (
        <NewsModal open={newsModal} close={() => setNewsModal(false)} />
      )}
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    theme: state.theme.isLightMode,
  };
};
export default connect(mapStateToProps)(NewsPanel);